import { RQ } from 'utils';
import { addClickAnalytics } from 'utils/analytics';

export default {
  downLoadApp: async function () {
    addClickAnalytics({ LogTitle: '下载APP查看订单详情' });
    if (this.enterprise) {
      this.$router.push({ path: `/download?enterprise=${this.enterprise}` });
    }
  }
};



// WEBPACK FOOTER //
// ./src/module/cart/paySuccess/action.js